import { Box, Link } from '@mui/material'
import instagram from './svg/instagram.svg';

export default function Instagram({to}) {
  return (    
    <Link href={to}>
      <Box component="img" sx={{ width: '20px', display:'inline-block', marginBottom:'-2px', marginLeft:'10px'}} alt="NOB 4.0" src={instagram} />    
    </Link>
  )
}